import { PaperCard, PaperCardContent, PaperCardFooterDetail, PaperCardFooterImage, Wrapper, WrapperContent } from './style';
import SessionLimiterStyled from '../../atoms/SessionLimiter/styled';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CircleIcon from '../../atoms/CircleIcon';
import seta from '../../../images/triangle.png';
import SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const ContentPaymentBlockedOverSchedule = () => {
  return (
    <>
      <Wrapper small={'false'}></Wrapper>
      <WrapperContent>
        <Grid container item sx={{ mb: 4 }}>
          <Grid xs={0} md={3}></Grid>
          <Grid xs={12} md={6} item>
            <PaperCard>
              <PaperCardContent>
                <Box>
                  <Box sx={{ mb: 2 }}>
                    <CircleIcon icon={<SentimentVeryDissatisfiedIcon />} />
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="h3">Ops!</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2">
                      Identificamos uma jornada ativa neste CPF e o próximo passo seria uma <b>consulta de retorno</b>. Por
                      favor entre em contato com o time de atendimento para finalizar seu agendamento.
                    </Typography>
                  </Box>
                  <Box sx={{ pt: 3 }}>
                    <Button
                      variant="contained"
                      href={
                        'https://api.whatsapp.com/send/?phone=5511936218081&text=Ol%C3%A1,%20gostaria%20de%20agendar%20minha%20consulta%20de%20retorno'
                      }
                      target="_self"
                      sx={{ letterSpacing: 0 }}
                      endIcon={<WhatsAppIcon />}
                    >
                      Fale com a gente
                    </Button>
                  </Box>
                  <SessionLimiterStyled />
                </Box>
              </PaperCardContent>
              <PaperCardFooterDetail sx={{ mb: 7 }}>
                <PaperCardFooterImage sx={{ backgroundImage: `url(${seta})`, height: '16px' }}></PaperCardFooterImage>
              </PaperCardFooterDetail>
            </PaperCard>
          </Grid>
          <Grid xs={0} md={3}></Grid>
        </Grid>
      </WrapperContent>
    </>
  );
};

export default ContentPaymentBlockedOverSchedule;
